import React, { Suspense } from 'react';
import { Redirect, Switch } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { LayoutSplashScreen, ContentRoute } from "../../../../_metronic/layout";
import { ObjectEdit } from '../../../../_metronic/layout/components/basePage/pages/object-edit/ObjectEdit';
import ObjectsPage from '../../../../_metronic/layout/components/basePage/pages/ObjectsPage';
import { FilterObjectsUIProvider } from '../../../../_metronic/layout/components/basePage/pages/FilterObjectsUIContext';
import {
  rowFormatter,
  formFields,
  otherFields,
  initObject,
  ObjectEditSchema,
  provienceColumns,
  prepareFilter,
  provienceFilterFields,
  filterInitialValues,
} from './AuditFormReportUtils';


const ProvienceAuditFormReportPage = () => {

  const { currentState } = useSelector(
    (state) => ({ currentState: state.provienceAuditFormReports }),
    shallowEqual
  );

  let isFullAccess = false;
  const { menuList } = useSelector(
    (state) => ({ menuList: state.auth.menu }),
    shallowEqual
  );

  if (menuList.find(q => q.url == "/reportsProvience")) {
    const temp = menuList.find(q => q.url == "/reportsProvience")
    isFullAccess = temp.isFullAccess;
  }


  return (
    <FilterObjectsUIProvider initialFilter={filterInitialValues}>
      <Suspense fallback={<LayoutSplashScreen />}>
        <Switch>

          <ContentRoute
            path="/reportsProvience"
            render={props =>
              <ObjectsPage
                rowFormatter={rowFormatter}
                filterByShowButton={true}
                AuditAction={false}
                haveGeneralAction={false}
                isFullAccess={isFullAccess}
                basePath="/reportsProvience"
                api="api/AuditFormResult"
                getFunctionName="GetProviencesReport"
                exportfuncName="GetExcelProviencesReport"
                currentState={currentState}
                columns={provienceColumns}
                prepareFilter={prepareFilter}
                filterFields={provienceFilterFields}
                filterInitialValues={filterInitialValues}
                enablePagination={false}
                haveExportButton={true}
              />
            }
          />

        </Switch>
      </Suspense>
    </FilterObjectsUIProvider>
  )
}

export default ProvienceAuditFormReportPage



